import React from 'react';
import Image from '~/components/Image';
import BackPhoto from '~/public/static/listflow/imageangles/back.png';
import BottomPhoto from '~/public/static/listflow/imageangles/bottom.png';
import DefectPhoto from '~/public/static/listflow/imageangles/defect.png';
import DetailPhoto from '~/public/static/listflow/imageangles/detail.png';
import FrontPhoto from '~/public/static/listflow/imageangles/front.png';
import LeftSidePhoto from '~/public/static/listflow/imageangles/left.png';
import MainPhoto from '~/public/static/listflow/imageangles/main.png';
import RightSidePhoto from '~/public/static/listflow/imageangles/right.png';
import TopPhoto from '~/public/static/listflow/imageangles/top.png';

interface Props {}

const angles = [
  {
    label: 'Main',
    image: MainPhoto,
  },
  {
    label: 'Top',
    image: TopPhoto,
  },
  {
    label: 'Bottom',
    image: BottomPhoto,
  },
  {
    label: 'Front',
    image: FrontPhoto,
  },
  {
    label: 'Back',
    image: BackPhoto,
  },
  {
    label: 'Right Side',
    image: RightSidePhoto,
  },
  {
    label: 'Left Side',
    image: LeftSidePhoto,
  },
  {
    label: 'Detail',
    image: DetailPhoto,
  },
  {
    label: 'Defect',
    image: DefectPhoto,
  },
];

const SuggestedAngles: React.FC<Props> = () => (
  <div className="grid grid-cols-4 gap-4 md:grid-cols-4 xl:grid-cols-6">
    {angles.map(angle => (
      <div key={angle.label}>
        <div className="text-slate-green-500 text-center text-sm">
          {angle.label}
        </div>
        <Image src={angle.image} className="mx-auto h-16 w-16" />
      </div>
    ))}
  </div>
);

export default SuggestedAngles;
